import React from 'react';

const Popup = ({ img }) => (
  <div className="popup">
    <img src={`${img.replace('https://', 'https://i.')}.jpg`} className="popup-image" />
  </div>
);
export default Popup;
